'use client'
import { useEffect, useState } from 'react';
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from 'contexts/LanguageContext';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Spinner from 'components/spinner';
// import { Link } from '@fluentui/react/lib/Link';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';

export default function Presences() {
    const {lang, res} = useLanguage();
    const navigate = useNavigate();
    const msal = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [presences, setPresences] = useState<any[]>([]);
    const [presencesLoading, setPresencesLoading] = useState(false);
    const _columns: IColumn[] = [
        { key: 'column1', name: res["Nom (Formation)"], fieldName: 'titre', minWidth: 100, maxWidth: 450, isResizable: true,
            onRender: (item) => (
                // eslint-disable-next-line react/jsx-no-bind
                <span>
                  {item.titre}
                </span>
            )
        },
        { key: 'column2', name: res["Début (Formation)"], fieldName: 'debut', minWidth: 100, maxWidth: 150, isResizable: true },
        { key: 'column3', name: res["Duree"], fieldName: 'duree', minWidth: 100, maxWidth: 150, isResizable: true },
        { key: 'column4', name: res["Formateur"], fieldName: 'formateur', minWidth: 100, maxWidth: 150, isResizable: true }
    ];

    useEffect(() => {
        setPresencesLoading(true);
        const getPresences = async function() {
            const fetchedPresences = await ServiceCoursesProvider.provider.getPresences(msal, lang);
            const presencesToUse: any[] = [];
            if (fetchedPresences) {
                fetchedPresences.forEach((p: any) => {
                    const startDate = new Date(p.debut);
                    const endDate = new Date(p.fin);
                    presencesToUse.push({
                        id: p.id,
                        titre: p.titre[lang],
                        debut: startDate.toLocaleString(lang+"-CA", {dateStyle: 'short',timeStyle: 'short'}),
                        fin: endDate.toLocaleString(lang+"-CA", {dateStyle: 'short',timeStyle: 'short'}),
                        duree: p.duree,
                        formateur: p.formateur ?? ""
                    });
                });
            }
            setPresences(presencesToUse);
            setPresencesLoading(false);
        }
        if (isAuthenticated) {
            getPresences();
        }
    }, [isAuthenticated]);

    return (
        <div className="mx-auto mb20">
            <h3 className="h3 mb-4 aos-init aos-animate">{res["Presences"]}</h3>
            {(presencesLoading) ? (
                <div className="mh300">
                    <Spinner />
                </div>
            ) : (
                <DetailsList
                    items={presences}
                    columns={_columns}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                />
            )}
        </div>
    );
}
